import { Map } from 'immutable';

import { SET_MODE, VIEW_MODE } from './constants';

const initialState = Map({
  mode: VIEW_MODE,
});

export default (state: Map<any, any> = initialState, action: any) => {
  switch (action.type) {
    case SET_MODE: {
      return state.set('mode', action.mode);
    }

    default: {
      return state;
    }
  }
};
